import React from 'react';
import { motion } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

export default function AboutUs() {
    return (
        <div style={{ background: 'var(--bg-page)', minHeight: '100vh', color: 'var(--text-primary)', padding: '120px 40px' }}>
            <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
                <motion.h1
                    initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
                    style={{ fontSize: '48px', fontWeight: '600', marginBottom: '24px', letterSpacing: '-0.02em' }}
                >
                    About Oblique
                </motion.h1>
                <p style={{ fontSize: '20px', color: 'var(--text-secondary)', marginBottom: '60px', lineHeight: 1.6 }}>
                    We believe Quality Assurance is a revenue engine, not a cost center. Oblique was built by sales leaders and QA experts who were tired of losing deals to compliance blindspots.
                </p>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '24px', textAlign: 'left' }}>
                    <div style={{ padding: '32px', background: 'var(--bg-surface)', borderRadius: '16px', border: '1px solid var(--border)' }}>
                        <ObliqueIcon name="groups" style={{ color: 'var(--accent)', width: '32px', height: '32px', marginBottom: '16px' }} />
                        <h3 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '12px' }}>For Teams</h3>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: 1.5, fontSize: '15px' }}>Bridging the gap between active Sales Agents and dedicated Quality Analysts.</p>
                    </div>

                    <div style={{ padding: '32px', background: 'var(--bg-surface)', borderRadius: '16px', border: '1px solid var(--border)' }}>
                        <ObliqueIcon name="track_changes" style={{ color: 'var(--warning)', width: '32px', height: '32px', marginBottom: '16px' }} />
                        <h3 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '12px' }}>The Mission</h3>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: 1.5, fontSize: '15px' }}>Eliminate the "silent leaks" in your sales pipeline through immediate accountability.</p>
                    </div>

                    <div style={{ padding: '32px', background: 'var(--bg-surface)', borderRadius: '16px', border: '1px solid var(--border)' }}>
                        <ObliqueIcon name="public" style={{ color: 'var(--blue)', width: '32px', height: '32px', marginBottom: '16px' }} />
                        <h3 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '12px' }}>Anywhere</h3>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: 1.5, fontSize: '15px' }}>Built to adapt dynamically to your global footprint, from Tier 1 to offshore.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
